import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import {
  CarsCarousel,
  RecentlyViewedCarsCarousel,
} from '@cinch-nx/shared-cars-carousel'
import { useEffect } from 'react'
import { Tabs } from '../shared/tabs'
import { SortingCriteria } from '@cinch-nx/data-search'

interface Tabs {
  key: string
  title: string
  content: JSX.Element
}

const tabButtonTrackingEvent = (tabTitle: string) => ({
  eventName: `Personalised Component`,
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: EventNames.click,
      category: 'Personalised Component',
      label: `${tabTitle} tab`,
      action: 'Tab Clicked',
    },
  },
})

export const ReturningCustomerTabs = () => {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    setTimeout(() => {
      trackEvent({
        eventName: 'Welcome back module',
        type: TrackingEventTypes.PAGE,
        data: {
          event: {
            category: 'welcome-back-module',
            label: 'personalised-component',
            action: 'triggered',
            name: 'load',
          },
        },
      })
    }, 3000)
  }, [])

  return (
    <Tabs
      ariaLabel="recently-viewed-and-new-cars-list"
      tabs={[
        {
          label: 'Recently viewed',
          trackingEvent: tabButtonTrackingEvent('Recently viewed'),
          panelContent: (
            <RecentlyViewedCarsCarousel showBrowseAllCarsCard={true} />
          ),
        },
        {
          label: 'New cars',
          trackingEvent: tabButtonTrackingEvent('New cars'),
          panelContent: (
            <CarsCarousel
              carsCondition="new"
              disclaimer="Sold by our partner Marshall Motor Group"
              sortBy={SortingCriteria.FIRST_PUBLISHED_DATE_DESC}
            />
          ),
        },
      ]}
    />
  )
}
